import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export const MaxDate = (date: moment.Moment): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control && control.value) {
      const { value } = control;
      const validDate = moment.isMoment(value);
      if (validDate && value.isAfter(date)) {
        return { maxDate: { max: date } };
      }
    }
    return null;
  };
};
